const preventEventDefault = event => event.preventDefault()

const stopEventPropagation = event => event.stopPropagation()

export { preventEventDefault, stopEventPropagation }
